// Multilingual translations FR / NL / EN for RYCM
export const translations = {
  fr: {
    nav: {
      home: "Accueil", club: "Le Club", agenda: "Agenda", voile: "Voile",
      regattas: "Régates", stages: "Stages", motor: "Moteur",
      shop: "Boutique", gallery: "Galerie", contact: "Contact",
      login: "Connexion", register: "Inscription", dashboard: "Mon espace",
      admin: "Admin", logout: "Déconnexion", cart: "Panier",
    },
    common: {
      readMore: "En savoir plus", download: "Télécharger", from: "À partir de",
      submit: "Envoyer", cancel: "Annuler", confirm: "Confirmer", loading: "Chargement…",
      back: "Retour", year: "Année", all: "Tous",
    },
    home: {
      eyebrow: "Fondé en 1928 · Île Monsin, Liège",
      heroTitle: "Royal Yacht\nClub de la Meuse",
      heroSub: "Depuis bientôt un siècle, le RYCM cultive l'art de la voile sur la Meuse à Liège — régates, stages, plaisance et esprit de club.",
      ctaPrimary: "Devenir membre",
      ctaSecondary: "Voir les stages",
      ctaTertiary: "Calendrier 2026",
      ctaPrimaryLink: "/club#admission",
      ctaSecondaryLink: "/stages",
      ctaTertiaryLink: "/agenda",
      newsTitle: "Actualités",
      newsSub: "Les dernières nouvelles du club.",
      quickLinksTitle: "Accès rapide",
      quickLinks: [
        { label: "Voile", path: "/voile" },
        { label: "Stages", path: "/stages" },
        { label: "Régates", path: "/regattas" },
        { label: "Moteur", path: "/motor" },
        { label: "Boutique", path: "/shop" },
        { label: "Contact", path: "/contact" },
      ],
      pillars: [
        { title: "Voile", text: "École et perfectionnement, brevets fédéraux." },
        { title: "Régates", text: "5 régates phares organisées chaque saison." },
        { title: "Stages", text: "Jeunes (7-16 ans) et adultes, toute l'année." },
        { title: "Plaisance", text: "Section moteur, sécurité, brevets VHF." },
      ],
      weatherTitle: "Météo & Meuse",
      weatherText: "Consultez la météo locale et le débit de la Meuse avant chaque sortie.",
      weatherLinks: [
        { label: "Météo Liège", url: "https://www.meteo.be/fr/liege" },
        { label: "Débit Meuse", url: "https://hydrometrie.wallonie.be/home/observations/debit.html?station=DGH%2F5451" },
      ],
    },
    club: {
      eyebrow: "Le Club",
      title: "Près d'un siècle de voile sur la Meuse.",
      lead: "Fondé en 1928, le Royal Yacht Club de la Meuse est l'un des plus anciens clubs nautiques de Wallonie. Installé sur l'Île Monsin à Liège, il rassemble passionnés de voile, de moteur et de compétition.",
      historyTitle: "Notre histoire",
      historyText: "Depuis 1928, le RYCM œuvre à promouvoir la voile sur la Meuse. Notre clubhouse, situé sur l'Île Monsin, est un lieu emblématique de la vie nautique liégeoise.",
      locationTitle: "Situation",
      locationText: "Rue de l'Île Monsin 2, 4020 Liège, Belgique. Accès facile depuis le centre-ville et l'autoroute E40.",
      boardTitle: "Conseil d'administration",
      boardSub: "L'équipe qui fait vivre le club.",
      duesTitle: "Cotisations",
      duesSub: "Devenez membre du RYCM pour la saison.",
      dues: [
        { name: "Cotisation Junior (-18)", price: "120 €", note: "Stages inclus" },
        { name: "Cotisation Adulte", price: "350 €", note: "Accès complet" },
        { name: "Cotisation Famille", price: "520 €", note: "2 adultes + enfants" },
        { name: "Membre Associé", price: "180 €", note: "Sans bateau" },
      ],
      admissionTitle: "Demande d'admission",
      admissionSub: "Remplissez ce formulaire pour rejoindre le club. Le bureau examine chaque candidature et vous recontactera dans les 14 jours.",
      privacyTitle: "Vie privée / RGPD",
      privacyText: "Le RYCM respecte le règlement général sur la protection des données. Vos données ne sont utilisées que pour la gestion du club et ne sont jamais transmises à des tiers.",
      welcomeTitle: "Bienvenue à bord, futur membre !",
      welcomeText: "Rejoindre le Royal Yacht Club de la Meuse, c'est intégrer une communauté de passionnés fondée en 1928 et profiter d'installations à l'Île Monsin : pontons, hangars, club-house, école de voile et un calendrier de régates et événements. Téléchargez le formulaire de demande d'admission ci-dessous, complétez-le et joignez-le à votre dossier en ligne ou envoyez-le au secrétariat. Votre candidature sera examinée par le conseil d'administration.",
    },
    admission: {
      firstName: "Prénom", lastName: "Nom", email: "Email", phone: "Téléphone",
      address: "Adresse", birthdate: "Date de naissance",
      type: "Type de cotisation",
      types: { junior: "Junior", adult: "Adulte", family: "Famille", associate: "Associé" },
      motivation: "Motivation (optionnel)",
      submit: "Envoyer la demande",
      success: "Demande reçue. Le bureau vous recontactera bientôt.",
    },
    agenda: {
      eyebrow: "Agenda 2026",
      title: "Le calendrier du club.",
      lead: "Tous les événements, régates et stages réunis. Cliquez sur une date pour voir le détail.",
      legend: { event: "Événement club", regatta: "Régate", stage: "Stage" },
      noEvents: "Aucun événement à cette date.",
      downloadPlanning: "Télécharger le planning annuel",
    },
    voile: {
      eyebrow: "Voile",
      title: "L'école de voile RYCM.",
      lead: "Une école reconnue par la Fédération Francophone du Yachting Belge. Cours pour tous niveaux, brevets fédéraux, sorties en mer.",
      schoolTitle: "L'école",
      schoolText: "Encadrement par des moniteurs brevetés. Apprentissage progressif sur dériveurs Optimist, Laser et quillards.",
      boatsTitle: "Bateaux utilisés",
      brevetsTitle: "Brevets voile",
      brevets: [
        "Brevet d'initiation",
        "Brevet de perfectionnement",
        "Brevet de skipper côtier",
        "Brevet de chef de bord hauturier",
      ],
      seaTripsTitle: "Sorties en mer",
      seaTripsText: "Chaque été, le club organise des sorties en mer du Nord et en Méditerranée pour les membres.",
    },
    regattas: {
      eyebrow: "Régates",
      title: "Cinq rendez-vous, une passion.",
      lead: "Le RYCM organise cinq régates chaque saison, ouvertes aux membres et invités.",
      noticeOfRace: "Avis de course",
      sailingInstructions: "Instructions de course",
      results: "Classements",
      generalRanking: "Classement général",
      gallery: "Galerie photos",
      noDocs: "Documents à venir.",
      noResults: "Résultats à venir.",
      tabUpcoming: "À venir",
      tabArchive: "Archive",
      archiveLabel: "Édition passée",
      viewResults: "Voir les classements",
      archiveEmpty: "Aucune régate passée pour le moment.",
      upcomingEmpty: "Aucune régate prévue prochainement.",
    },
    stages: {
      eyebrow: "Stages",
      title: "Apprendre à naviguer.",
      lead: "Stages encadrés par nos moniteurs, pour les jeunes (7-16 ans) et les adultes (17+).",
      tabs: { jeunes: "Stages Jeunes", adultes: "Stages Adultes" },
      ages: "Ages", duration: "Durée", places: "Places",
      placesLeft: "places restantes", full: "Complet",
      lastPlaces: "Dernières places !",
      share: "Partager",
      waitlistOne: "1 personne déjà en liste d'attente",
      waitlistMany: "{n} personnes déjà en liste d'attente",
      register: "S'inscrire",
      registerTitle: "Inscription au stage",
      participantName: "Nom du participant",
      participantBirthdate: "Date de naissance",
      parentName: "Nom du parent (si mineur)",
      parentEmail: "Email du parent",
      parentPhone: "Téléphone",
      medical: "Informations médicales (allergies, etc.)",
      notes: "Notes",
      submit: "Confirmer l'inscription",
      success: "Inscription reçue. Vous recevrez une confirmation sous 48h.",
    },
    motor: {
      eyebrow: "Moteur",
      title: "Section moteur & plaisance.",
      lead: "Le RYCM accueille également les passionnés de motonautisme et de plaisance fluviale.",
      securityTitle: "Team Sécurité",
      securityText: "Notre équipe sécurité veille au bon déroulement des régates et des sorties. Bateaux de sécurité disponibles 7j/7.",
      boatsTitle: "Bateaux de sécurité",
      boats: [
        { tag: "Sécurité 1", name: "Bateau de sécurité 1", text: "Équipé radio VHF, défibrillateur, kit de secours.", image: "https://images.unsplash.com/photo-1542856391-010fb87dcfed?w=1200" },
        { tag: "Sécurité 2", name: "Bateau de sécurité 2", text: "Équipé radio VHF, défibrillateur, kit de secours.", image: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=1200" },
        { tag: "Sécurité 3", name: "Bateau de sécurité 3", text: "Équipé radio VHF, défibrillateur, kit de secours.", image: "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?w=1200" },
      ],
      brevetsTitle: "Brevets",
      brevetsList: [
        { name: "Brevet de navigation", text: "Obligatoire pour piloter un bateau à moteur en Belgique." },
        { name: "Brevet VHF", text: "Permis radio maritime indispensable pour la sécurité." },
      ],
    },
    shop: {
      eyebrow: "Boutique",
      title: "Couleurs du club.",
      lead: "Vêtements & accessoires officiels, réservation de stages et inscriptions aux événements. Commandez en ligne et récupérez au club-house.",
      categories: { vetements: "Vêtements", accessoires: "Accessoires", stages: "Stages", evenements: "Événements", all: "Tous" },
      addToCart: "Ajouter au panier", inStock: "En stock", outOfStock: "Rupture",
      size: "Taille", color: "Couleur", quantity: "Quantité",
      cartTitle: "Mon panier", cartEmpty: "Votre panier est vide.",
      total: "Total", checkout: "Passer commande", remove: "Retirer",
      backToShop: "Retour à la boutique",
      waitlistTitle: "Ce stage est complet",
      waitlistText: "Laissez vos coordonnées : nous vous préviendrons par e-mail dès qu'une place se libère.",
      waitlistBtn: "Rejoindre la liste d'attente",
      waitlistSuccess: "C'est noté ! Vous serez prévenu(e) par e-mail dès qu'une place se libère.",
      checkoutTitle: "Finaliser la commande",
      contactInfo: "Informations de contact",
      name: "Nom complet", email: "Email", phone: "Téléphone",
      pickupTitle: "Mode de retrait",
      pickup: "Retrait au club-house (gratuit)",
      shipping: "Livraison à domicile (frais en sus)",
      address: "Adresse de livraison",
      payNow: "Payer avec Mollie", continueShopping: "Continuer mes achats",
      paymentSuccess: "Paiement confirmé !",
      paymentSuccessText: "Merci ! Votre commande a été reçue. Vous recevrez les détails de retrait par email.",
      paymentPending: "Paiement en cours…",
      paymentFailed: "Le paiement n'a pas abouti. Vous pouvez réessayer.",
      noOnlinePayment: "Le paiement en ligne n'est pas encore configuré. Votre commande a été enregistrée — le club vous contactera pour finaliser.",
      stageDates: "Dates", places: "Places", placesLeft: "places restantes",
      stageOpen: "Inscriptions ouvertes", stageFull: "Complet", stageClosed: "Fermé",
      bookStage: "Réserver une place", participantInfo: "Informations du participant",
      participantName: "Nom du participant", participantNotes: "Notes (médical, allergies…)",
      firstName: "Prénom", lastName: "Nom", birthdate: "Date de naissance",
      phone: "Téléphone", email: "E-mail", address: "Adresse",
      weight: "Poids", height: "Taille",
      boatType: "Bateau souhaité", boatMono: "Monoplace", boatBi: "Biplace",
      experience: "Expérience en voile",
      experiencePlaceholder: "Décrivez votre niveau, vos précédents stages ou licences…",
      requiredFields: "Champs obligatoires",
      sectionVet: "Vêtements & accessoires", sectionStages: "Réservation de stages", sectionEvents: "Inscriptions aux événements",
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Instants de mer.",
      lead: "La vie du club en images.",
      allYears: "Toutes les années",
    },
    contact: {
      eyebrow: "Contact",
      title: "Une question ? Écrivez-nous.",
      lead: "Notre équipe vous répond sous 48 heures. Pour les paiements (cotisations, stages), un virement bancaire vous sera communiqué.",
      name: "Nom", email: "Email", subject: "Objet", message: "Message",
      send: "Envoyer", success: "Message envoyé. Nous vous répondrons bientôt.",
      address: "Adresse",
      addressValue: "Rue de l'Île Monsin 2, 4020 Liège, Belgique",
      phone: "Téléphone", hours: "Horaires",
      hoursValue: "Mar–Dim : 9h00 – 18h00",
      bankTitle: "Coordonnées bancaires",
      bankSub: "Pour les cotisations, virement bancaire uniquement.",
      bankHolder: "Titulaire",
      bankHolderValue: "Royal Yacht Club de la Meuse ASBL",
      iban: "IBAN", bic: "BIC", communication: "Communication",
      communicationValue: "Votre nom + objet (cotisation, stage…)",
      followUs: "Suivez-nous",
      faqTitle: "Questions fréquentes",
    },
    auth: {
      loginTitle: "Connexion membre",
      loginSub: "Accédez à votre espace.",
      registerTitle: "Créer un compte",
      registerSub: "Rejoignez la communauté.",
      email: "Email", password: "Mot de passe", name: "Nom complet",
      submitLogin: "Se connecter", submitRegister: "S'inscrire",
      noAccount: "Pas encore membre ?", hasAccount: "Déjà inscrit ?",
      signUpHere: "Inscrivez-vous", loginHere: "Connectez-vous",
      forgot: "Mot de passe oublié ?",
      forgotTitle: "Mot de passe oublié",
      forgotSub: "Indiquez votre email, nous vous enverrons un lien.",
      forgotSubmit: "Envoyer le lien",
      forgotSent: "Si l'email existe, un lien a été généré (consultez les logs du serveur ou demandez à l'admin).",
      resetTitle: "Réinitialiser le mot de passe",
      resetSub: "Choisissez un nouveau mot de passe.",
      newPassword: "Nouveau mot de passe",
      resetSubmit: "Réinitialiser",
      resetSuccess: "Mot de passe mis à jour. Vous pouvez vous connecter.",
    },
    dashboard: {
      welcome: "Bienvenue",
      myReservations: "Mes réservations",
      myOrders: "Mes commandes",
      myStages: "Mes stages",
      myDownloads: "Téléchargements",
      profileTab: "Profil",
      stage: "Stage",
      paid: "Payé",
      noOrders: "Aucune commande pour le moment.",
      noStages: "Aucune inscription à un stage.",
      noDownloads: "Aucun document membres pour l'instant.",
      profileInfo: "Mes informations",
      profileSaved: "Informations sauvegardées.",
      phone: "Téléphone",
      address: "Adresse",
      saveProfile: "Enregistrer",
      changePassword: "Changer mon mot de passe",
      currentPassword: "Mot de passe actuel",
      passwordChanged: "Mot de passe modifié.",
      updatePassword: "Mettre à jour",
      newReservation: "Nouvelle réservation",
      noReservations: "Vous n'avez aucune réservation pour le moment.",
      type: "Type", item: "Élément", date: "Date", status: "Statut", actions: "Actions",
      cancel: "Annuler", cancelled: "Annulée", pending: "En attente", confirmed: "Confirmée", rejected: "Refusée",
      reserveCourse: "Réserver un cours", reserveBoat: "Réserver un bateau",
      selectItem: "Sélectionner", notes: "Notes (optionnel)",
      confirm: "Confirmer", cancelAction: "Fermer",
      bookingCreated: "Réservation créée.",
      bookingCancelled: "Réservation annulée.",
    },
    treasury: {
      title: "Espace trésorerie",
      tabs: { summary: "Résumé", payments: "Paiements", garages: "Garages & parkings", fees: "Tarifs" },
      cats: { cotisation: "Cotisations", entry_fee: "Droits d'entrée", garage: "Garages", parking: "Parkings", crane: "Grue", ffyb: "Licences FFYB" },
      recordPayment: "Enregistrer un paiement",
      assignGarage: "Attribuer garage / parking",
      selectMember: "Sélectionner un membre",
      selectItem: "Sélectionner un tarif",
    },
    secretary: {
      title: "Espace secrétaire",
    },
    admin: {
      title: "Tableau de bord admin",
      tabs: {
        overview: "Vue d'ensemble", reservations: "Réservations",
        admissions: "Admissions", stages: "Stages",
        messages: "Messages", orders: "Commandes",
        products: "Produits", pdfs: "Documents PDF",
      },
      stats: {
        users: "Membres", reservations: "Réservations", pending: "En attente",
        admissions: "Admissions", new: "Nouvelles",
        stage_regs: "Insc. stages", messages: "Messages", orders: "Commandes",
        revenue: "Commandes payées", products: "Produits",
      },
      approve: "Approuver", reject: "Refuser", markRead: "Marquer lu", contact: "Contacter",
      uploadPdf: "Téléverser un PDF",
      pdfTitle: "Titre", pdfCategory: "Catégorie",
      addProduct: "Ajouter un produit",
      productName: "Nom", productPrice: "Prix", productStock: "Stock",
      productCategory: "Catégorie", productSizes: "Tailles (séparées par ,)",
      productColors: "Couleurs (séparées par ,)", productImage: "Image",
      productDesc: "Description",
    },
    footer: {
      tagline: "Royal Yacht Club de la Meuse · Fondé en 1928",
      rights: "Tous droits réservés.",
      legal: "Mentions légales",
      privacy: "Vie privée",
    },
    levels: { beginner: "Débutant", intermediate: "Intermédiaire", advanced: "Avancé" },
  },
  nl: {
    nav: {
      home: "Home", club: "De Club", agenda: "Agenda", voile: "Zeilen",
      regattas: "Wedstrijden", stages: "Stages", motor: "Motor",
      shop: "Shop", gallery: "Galerij", contact: "Contact",
      login: "Inloggen", register: "Registreren", dashboard: "Mijn ruimte",
      admin: "Admin", logout: "Uitloggen", cart: "Winkelwagen",
    },
    common: { readMore: "Meer weten", download: "Downloaden", from: "Vanaf",
      submit: "Verzenden", cancel: "Annuleren", confirm: "Bevestigen", loading: "Bezig…",
      back: "Terug", year: "Jaar", all: "Alle" },
    home: {
      eyebrow: "Opgericht in 1928 · Île Monsin, Luik",
      heroTitle: "Royal Yacht\nClub de la Meuse",
      heroSub: "Al bijna een eeuw cultiveert RYCM de zeilkunst op de Maas in Luik — wedstrijden, stages, plezier en clubgeest.",
      ctaPrimary: "Word lid", ctaSecondary: "Bekijk de stages", ctaTertiary: "Kalender 2026",
      ctaPrimaryLink: "/club#admission", ctaSecondaryLink: "/stages", ctaTertiaryLink: "/agenda",
      newsTitle: "Actualiteiten", newsSub: "Het laatste clubnieuws.",
      quickLinksTitle: "Snelle toegang",
      quickLinks: [
        { label: "Zeilen", path: "/voile" }, { label: "Stages", path: "/stages" },
        { label: "Wedstrijden", path: "/regattas" }, { label: "Motor", path: "/motor" },
        { label: "Shop", path: "/shop" }, { label: "Contact", path: "/contact" },
      ],
      pillars: [
        { title: "Zeilen", text: "School en vervolmaking, federale brevetten." },
        { title: "Wedstrijden", text: "5 belangrijke wedstrijden per seizoen." },
        { title: "Stages", text: "Jeugd (7-16) en volwassenen, hele jaar." },
        { title: "Plezier", text: "Motorsectie, veiligheid, VHF-brevetten." },
      ],
      weatherTitle: "Weer & Maas",
      weatherText: "Raadpleeg het lokale weer en het Maasdebiet voor elke uitvaart.",
      weatherLinks: [
        { label: "Weer Luik", url: "https://www.meteo.be/nl/luik" },
        { label: "Maasdebiet", url: "https://hydrometrie.wallonie.be/home/observations/debit.html?station=DGH%2F5451" },
      ],
    },
    club: {
      eyebrow: "De Club",
      title: "Bijna een eeuw zeilen op de Maas.",
      lead: "Opgericht in 1928 is de Royal Yacht Club de la Meuse een van de oudste zeilclubs van Wallonië, gevestigd op Île Monsin in Luik.",
      historyTitle: "Onze geschiedenis",
      historyText: "Sinds 1928 promoot RYCM het zeilen op de Maas. Ons clubhuis op Île Monsin is een emblematische plek van het Luikse watersportleven.",
      locationTitle: "Ligging",
      locationText: "Rue de l'Île Monsin 2, 4020 Luik, België. Vlot bereikbaar vanuit het centrum en de E40.",
      boardTitle: "Bestuur", boardSub: "Het team dat de club leidt.",
      duesTitle: "Lidgeld", duesSub: "Word lid van RYCM voor het seizoen.",
      dues: [
        { name: "Junior (-18)", price: "120 €", note: "Stages inbegrepen" },
        { name: "Volwassene", price: "350 €", note: "Volledige toegang" },
        { name: "Familie", price: "520 €", note: "2 volwassenen + kinderen" },
        { name: "Geassocieerd lid", price: "180 €", note: "Zonder boot" },
      ],
      admissionTitle: "Aanvraag tot lidmaatschap",
      admissionSub: "Vul dit formulier in om lid te worden. Het bestuur behandelt elke aanvraag binnen 14 dagen.",
      privacyTitle: "Privacy / AVG",
      privacyText: "RYCM respecteert de algemene verordening gegevensbescherming.",
      welcomeTitle: "Welkom aan boord, toekomstig lid!",
      welcomeText: "Lid worden van de Royal Yacht Club de la Meuse betekent deel uitmaken van een gemeenschap van gepassioneerden, opgericht in 1928, met faciliteiten op Île Monsin: pontons, loodsen, clubhuis, zeilschool en een kalender vol wedstrijden en evenementen. Download hieronder het aanvraagformulier, vul het in en voeg het toe aan uw online dossier of stuur het naar het secretariaat. Uw kandidatuur wordt onderzocht door de raad van bestuur.",
    },
    admission: {
      firstName: "Voornaam", lastName: "Naam", email: "E-mail", phone: "Telefoon",
      address: "Adres", birthdate: "Geboortedatum",
      type: "Type lidmaatschap",
      types: { junior: "Junior", adult: "Volwassen", family: "Familie", associate: "Geassocieerd" },
      motivation: "Motivatie (optioneel)",
      submit: "Aanvraag versturen",
      success: "Aanvraag ontvangen. Het bestuur neemt spoedig contact op.",
    },
    agenda: {
      eyebrow: "Agenda 2026", title: "De clubkalender.",
      lead: "Alle evenementen, wedstrijden en stages. Klik op een datum voor details.",
      legend: { event: "Clubevenement", regatta: "Wedstrijd", stage: "Stage" },
      noEvents: "Geen evenementen op deze datum.",
      downloadPlanning: "Jaarplanning downloaden",
    },
    voile: {
      eyebrow: "Zeilen", title: "De zeilschool van RYCM.",
      lead: "Erkend door de Vlaamse Yachting Federatie. Cursussen voor alle niveaus, federale brevetten, zeetochten.",
      schoolTitle: "De school",
      schoolText: "Begeleiding door gediplomeerde instructeurs.",
      boatsTitle: "Gebruikte boten", brevetsTitle: "Brevetten",
      brevets: ["Initiatiebrevet", "Vervolmakingsbrevet", "Kustskipperbrevet", "Hoge zee schipper"],
      seaTripsTitle: "Zeetochten",
      seaTripsText: "Elke zomer organiseert de club zeetochten naar de Noordzee en Middellandse Zee.",
    },
    regattas: {
      eyebrow: "Wedstrijden", title: "Vijf afspraken, één passie.",
      lead: "RYCM organiseert vijf wedstrijden per seizoen.",
      noticeOfRace: "Wedstrijdbericht", sailingInstructions: "Wedstrijdinstructies",
      results: "Uitslagen", generalRanking: "Algemeen klassement", gallery: "Fotogalerij",
      noDocs: "Documenten binnenkort beschikbaar.", noResults: "Resultaten binnenkort.",
      tabUpcoming: "Komende", tabArchive: "Archief", archiveLabel: "Vorige editie",
      viewResults: "Bekijk klassement",
      archiveEmpty: "Geen voorbije wedstrijden.", upcomingEmpty: "Geen komende wedstrijden.",
    },
    stages: {
      eyebrow: "Stages", title: "Leren zeilen.",
      lead: "Stages begeleid door onze instructeurs, voor jongeren (7-16) en volwassenen (17+).",
      tabs: { jeunes: "Jeugdstages", adultes: "Volwassenenstages" },
      ages: "Leeftijden", duration: "Duur", places: "Plaatsen",
      placesLeft: "plaatsen vrij", full: "Vol",
      lastPlaces: "Laatste plaatsen!",
      share: "Delen",
      waitlistOne: "1 persoon al op de wachtlijst",
      waitlistMany: "{n} personen al op de wachtlijst",
      register: "Inschrijven", registerTitle: "Stage-inschrijving",
      participantName: "Naam deelnemer", participantBirthdate: "Geboortedatum",
      parentName: "Naam ouder (indien minderjarig)", parentEmail: "E-mail ouder",
      parentPhone: "Telefoon", medical: "Medische info",
      notes: "Opmerkingen", submit: "Inschrijving bevestigen",
      success: "Inschrijving ontvangen. Bevestiging binnen 48u.",
    },
    motor: {
      eyebrow: "Motor", title: "Motor- en pleziersectie.",
      lead: "RYCM verwelkomt ook motorboot- en pleziervaartliefhebbers.",
      securityTitle: "Veiligheidsteam",
      securityText: "Ons veiligheidsteam ziet toe op het goede verloop van wedstrijden en uitvaarten.",
      boatsTitle: "Veiligheidsboten", brevetsTitle: "Brevetten",
      boats: [
        { tag: "Veiligheid 1", name: "Veiligheidsboot 1", text: "Uitgerust met VHF-radio, defibrillator, EHBO-kit.", image: "https://images.unsplash.com/photo-1542856391-010fb87dcfed?w=1200" },
        { tag: "Veiligheid 2", name: "Veiligheidsboot 2", text: "Uitgerust met VHF-radio, defibrillator, EHBO-kit.", image: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=1200" },
        { tag: "Veiligheid 3", name: "Veiligheidsboot 3", text: "Uitgerust met VHF-radio, defibrillator, EHBO-kit.", image: "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?w=1200" },
      ],
      brevetsList: [
        { name: "Vaarbrevet", text: "Verplicht om een motorboot te besturen in België." },
        { name: "VHF-brevet", text: "Verplicht maritiem radiobrevet." },
      ],
    },
    shop: {
      eyebrow: "Shop", title: "Clubkleuren.",
      lead: "Officiële kleding en accessoires van RYCM: polos, t-shirts, jassen, petten en artikelen in clubkleuren. Bestel online en haal af in het clubhuis.",
      categories: { vetements: "Kleding", accessoires: "Accessoires", stages: "Stages", evenements: "Evenementen", all: "Alle" },
      addToCart: "Toevoegen", inStock: "Op voorraad", outOfStock: "Uitverkocht",
      size: "Maat", color: "Kleur", quantity: "Aantal",
      cartTitle: "Mijn winkelwagen", cartEmpty: "Uw winkelwagen is leeg.",
      total: "Totaal", checkout: "Afrekenen", remove: "Verwijderen",
      backToShop: "Terug naar de shop",
      waitlistTitle: "Deze stage is volzet",
      waitlistText: "Laat uw gegevens achter: wij verwittigen u per e-mail zodra er een plaats vrijkomt.",
      waitlistBtn: "Op de wachtlijst",
      waitlistSuccess: "Genoteerd! U wordt per e-mail verwittigd zodra er een plaats vrijkomt.",
      checkoutTitle: "Bestelling afronden",
      contactInfo: "Contactgegevens",
      name: "Volledige naam", email: "E-mail", phone: "Telefoon",
      pickupTitle: "Afhaalmethode",
      pickup: "Afhalen in clubhuis (gratis)",
      shipping: "Thuislevering (extra kosten)",
      address: "Leveringsadres",
      payNow: "Betalen met Mollie", continueShopping: "Verder winkelen",
      paymentSuccess: "Betaling bevestigd!",
      paymentSuccessText: "Bedankt! Uw bestelling is ontvangen.",
      paymentPending: "Betaling in behandeling…",
      paymentFailed: "De betaling is mislukt. U kunt opnieuw proberen.",
      noOnlinePayment: "Online betaling is nog niet ingesteld. Uw bestelling is opgeslagen — de club neemt contact op.",
      bookStage: "Plaats reserveren", participantInfo: "Gegevens deelnemer",
      participantName: "Naam deelnemer", participantNotes: "Opmerkingen (medisch, allergieën…)",
      firstName: "Voornaam", lastName: "Achternaam", birthdate: "Geboortedatum",
      weight: "Gewicht", height: "Lengte",
      boatType: "Gewenste boot", boatMono: "Eenmans", boatBi: "Tweemans",
      experience: "Zeilervaring",
      experiencePlaceholder: "Beschrijf uw niveau, vorige stages of brevetten…",
      requiredFields: "Verplichte velden",
      sectionVet: "Kleding & accessoires", sectionStages: "Stages boeken", sectionEvents: "Evenementen-inschrijving",
    },
    gallery: {
      eyebrow: "Galerij", title: "Momenten op het water.",
      lead: "Het clubleven in beeld.", allYears: "Alle jaren",
    },
    contact: {
      eyebrow: "Contact", title: "Een vraag? Schrijf ons.",
      lead: "Antwoord binnen 48 uur. Voor betalingen wordt een bankoverschrijving meegedeeld.",
      name: "Naam", email: "E-mail", subject: "Onderwerp", message: "Bericht",
      send: "Verzenden", success: "Bericht verzonden.",
      address: "Adres", addressValue: "Rue de l'Île Monsin 2, 4020 Luik, België",
      phone: "Telefoon", hours: "Openingsuren",
      hoursValue: "Di–Zo: 9u00 – 18u00",
      bankTitle: "Bankgegevens", bankSub: "Voor lidgeld, enkel via overschrijving.",
      bankHolder: "Houder", bankHolderValue: "Royal Yacht Club de la Meuse VZW",
      iban: "IBAN", bic: "BIC", communication: "Mededeling",
      communicationValue: "Uw naam + onderwerp",
      followUs: "Volg ons",
      faqTitle: "Veelgestelde vragen",
    },
    auth: {
      loginTitle: "Ledenlogin", loginSub: "Toegang tot uw ruimte.",
      registerTitle: "Account aanmaken", registerSub: "Word lid van de gemeenschap.",
      email: "E-mail", password: "Wachtwoord", name: "Volledige naam",
      submitLogin: "Inloggen", submitRegister: "Registreren",
      noAccount: "Nog geen lid?", hasAccount: "Al ingeschreven?",
      signUpHere: "Registreer hier", loginHere: "Log hier in",
      forgot: "Wachtwoord vergeten?",
      forgotTitle: "Wachtwoord vergeten",
      forgotSub: "Geef uw e-mail op, we sturen een link.",
      forgotSubmit: "Link versturen",
      forgotSent: "Als het e-mailadres bestaat, is een link gegenereerd.",
      resetTitle: "Wachtwoord opnieuw instellen",
      resetSub: "Kies een nieuw wachtwoord.",
      newPassword: "Nieuw wachtwoord",
      resetSubmit: "Opnieuw instellen",
      resetSuccess: "Wachtwoord bijgewerkt.",
    },
    dashboard: {
      welcome: "Welkom", myReservations: "Mijn reserveringen",
      newReservation: "Nieuwe reservering",
      noReservations: "Geen reserveringen.",
      type: "Type", item: "Element", date: "Datum", status: "Status", actions: "Acties",
      cancel: "Annuleren", cancelled: "Geannuleerd", pending: "In afwachting", confirmed: "Bevestigd", rejected: "Afgewezen",
      reserveCourse: "Cursus reserveren", reserveBoat: "Boot reserveren",
      selectItem: "Selecteer", notes: "Opmerkingen (optioneel)",
      confirm: "Bevestigen", cancelAction: "Sluiten",
      bookingCreated: "Reservering aangemaakt.",
      bookingCancelled: "Reservering geannuleerd.",
      myOrders: "Mijn bestellingen", myStages: "Mijn stages", myDownloads: "Downloads", profileTab: "Profiel",
      stage: "Stage", paid: "Betaald",
      noOrders: "Nog geen bestellingen.", noStages: "Geen stage-inschrijvingen.", noDownloads: "Nog geen documenten.",
      profileInfo: "Mijn gegevens", profileSaved: "Opgeslagen.", phone: "Telefoon", address: "Adres", saveProfile: "Bewaren",
      changePassword: "Wachtwoord wijzigen", currentPassword: "Huidig wachtwoord",
      passwordChanged: "Wachtwoord bijgewerkt.", updatePassword: "Bijwerken",
    },
    treasury: {
      title: "Penningmeester-ruimte",
      tabs: { summary: "Samenvatting", payments: "Betalingen", garages: "Garages & parking", fees: "Tarieven" },
      cats: { cotisation: "Lidgelden", entry_fee: "Inschrijfgeld", garage: "Garages", parking: "Parking", crane: "Kraan", ffyb: "FFYB-licenties" },
      recordPayment: "Betaling registreren", assignGarage: "Garage / parking toewijzen",
      selectMember: "Selecteer lid", selectItem: "Selecteer tarief",
    },
    secretary: { title: "Secretariaat" },
    admin: {
      title: "Admin dashboard",
      tabs: {
        overview: "Overzicht", reservations: "Reserveringen", admissions: "Aanvragen",
        stages: "Stages", messages: "Berichten", orders: "Bestellingen",
        products: "Producten", pdfs: "PDF-documenten",
      },
      stats: {
        users: "Leden", reservations: "Reserveringen", pending: "In afwachting",
        admissions: "Aanvragen", new: "Nieuw",
        stage_regs: "Stage insc.", messages: "Berichten", orders: "Bestellingen",
        revenue: "Betaald", products: "Producten",
      },
      approve: "Goedkeuren", reject: "Weigeren", markRead: "Markeer gelezen", contact: "Contact",
      uploadPdf: "PDF uploaden",
      pdfTitle: "Titel", pdfCategory: "Categorie",
      addProduct: "Product toevoegen",
      productName: "Naam", productPrice: "Prijs", productStock: "Voorraad",
      productCategory: "Categorie", productSizes: "Maten (door , gescheiden)",
      productColors: "Kleuren (door , gescheiden)", productImage: "Afbeelding",
      productDesc: "Beschrijving",
    },
    footer: {
      tagline: "Royal Yacht Club de la Meuse · Opgericht in 1928",
      rights: "Alle rechten voorbehouden.",
      legal: "Juridische vermeldingen", privacy: "Privacy",
    },
    levels: { beginner: "Beginner", intermediate: "Gevorderd", advanced: "Expert" },
  },
  en: {
    nav: {
      home: "Home", club: "The Club", agenda: "Agenda", voile: "Sailing",
      regattas: "Regattas", stages: "Camps", motor: "Motor",
      shop: "Shop", gallery: "Gallery", contact: "Contact",
      login: "Login", register: "Register", dashboard: "My space",
      admin: "Admin", logout: "Logout", cart: "Cart",
    },
    common: { readMore: "Learn more", download: "Download", from: "From",
      submit: "Send", cancel: "Cancel", confirm: "Confirm", loading: "Loading…",
      back: "Back", year: "Year", all: "All" },
    home: {
      eyebrow: "Founded in 1928 · Île Monsin, Liège",
      heroTitle: "Royal Yacht\nClub de la Meuse",
      heroSub: "For nearly a century, RYCM has cultivated the art of sailing on the Meuse in Liège — regattas, camps, leisure boating and club spirit.",
      ctaPrimary: "Become a member", ctaSecondary: "See the camps", ctaTertiary: "2026 Calendar",
      ctaPrimaryLink: "/club#admission", ctaSecondaryLink: "/stages", ctaTertiaryLink: "/agenda",
      newsTitle: "News", newsSub: "The latest from the club.",
      quickLinksTitle: "Quick access",
      quickLinks: [
        { label: "Sailing", path: "/voile" }, { label: "Camps", path: "/stages" },
        { label: "Regattas", path: "/regattas" }, { label: "Motor", path: "/motor" },
        { label: "Shop", path: "/shop" }, { label: "Contact", path: "/contact" },
      ],
      pillars: [
        { title: "Sailing", text: "School and advanced training, federal certificates." },
        { title: "Regattas", text: "5 flagship regattas every season." },
        { title: "Camps", text: "Youth (7-16) and adults, all year." },
        { title: "Boating", text: "Motor section, safety, VHF certificates." },
      ],
      weatherTitle: "Weather & Meuse",
      weatherText: "Check local weather and Meuse flow before each outing.",
      weatherLinks: [
        { label: "Weather Liège", url: "https://www.meteo.be/en/liege" },
        { label: "Meuse flow", url: "https://hydrometrie.wallonie.be/home/observations/debit.html?station=DGH%2F5451" },
      ],
    },
    club: {
      eyebrow: "The Club", title: "Nearly a century of sailing on the Meuse.",
      lead: "Founded in 1928, the Royal Yacht Club de la Meuse is one of the oldest nautical clubs in Wallonia, based on Île Monsin in Liège.",
      historyTitle: "Our history",
      historyText: "Since 1928, RYCM has promoted sailing on the Meuse. Our clubhouse on Île Monsin is an iconic place of Liège's nautical life.",
      locationTitle: "Location",
      locationText: "Rue de l'Île Monsin 2, 4020 Liège, Belgium. Easy access from city center and E40 highway.",
      boardTitle: "Board of Directors", boardSub: "The team running the club.",
      duesTitle: "Membership fees", duesSub: "Become a member for the season.",
      dues: [
        { name: "Junior (-18)", price: "€120", note: "Camps included" },
        { name: "Adult", price: "€350", note: "Full access" },
        { name: "Family", price: "€520", note: "2 adults + children" },
        { name: "Associate", price: "€180", note: "Without boat" },
      ],
      admissionTitle: "Admission request",
      admissionSub: "Fill out this form to join. The board reviews each application within 14 days.",
      privacyTitle: "Privacy / GDPR",
      privacyText: "RYCM complies with the General Data Protection Regulation.",
      welcomeTitle: "Welcome aboard, future member!",
      welcomeText: "Joining the Royal Yacht Club de la Meuse means becoming part of a community of enthusiasts founded in 1928, with facilities on Île Monsin: pontoons, hangars, clubhouse, sailing school and a calendar of regattas and events. Download the admission form below, complete it and attach it to your online application or send it to the secretariat. Your application will be reviewed by the board of directors.",
    },
    admission: {
      firstName: "First name", lastName: "Last name", email: "Email", phone: "Phone",
      address: "Address", birthdate: "Date of birth",
      type: "Membership type",
      types: { junior: "Junior", adult: "Adult", family: "Family", associate: "Associate" },
      motivation: "Motivation (optional)", submit: "Send request",
      success: "Request received. The board will contact you soon.",
    },
    agenda: {
      eyebrow: "2026 Agenda", title: "The club calendar.",
      lead: "All events, regattas and camps. Click a date for details.",
      legend: { event: "Club event", regatta: "Regatta", stage: "Camp" },
      noEvents: "No events on this date.",
      downloadPlanning: "Download annual planning",
    },
    voile: {
      eyebrow: "Sailing", title: "RYCM Sailing School.",
      lead: "Recognized by the Belgian Yachting Federation. Courses for all levels, federal certificates, sea trips.",
      schoolTitle: "The school",
      schoolText: "Supervised by certified instructors.",
      boatsTitle: "Boats used", brevetsTitle: "Sailing certificates",
      brevets: ["Initiation certificate", "Advanced certificate", "Coastal skipper", "Offshore skipper"],
      seaTripsTitle: "Sea trips",
      seaTripsText: "Every summer, the club organizes North Sea and Mediterranean trips for members.",
    },
    regattas: {
      eyebrow: "Regattas", title: "Five events, one passion.",
      lead: "RYCM organizes five regattas every season.",
      noticeOfRace: "Notice of Race", sailingInstructions: "Sailing Instructions",
      results: "Results", generalRanking: "Overall ranking", gallery: "Photo gallery",
      noDocs: "Documents coming soon.", noResults: "Results coming soon.",
      tabUpcoming: "Upcoming", tabArchive: "Archive", archiveLabel: "Past edition",
      viewResults: "View results",
      archiveEmpty: "No past regattas yet.", upcomingEmpty: "No upcoming regattas.",
    },
    stages: {
      eyebrow: "Camps", title: "Learn to sail.",
      lead: "Camps supervised by our instructors, for youth (7-16) and adults (17+).",
      tabs: { jeunes: "Youth Camps", adultes: "Adult Camps" },
      ages: "Ages", duration: "Duration", places: "Places",
      placesLeft: "places left", full: "Full",
      lastPlaces: "Last places!",
      share: "Share",
      waitlistOne: "1 person already on the waiting list",
      waitlistMany: "{n} people already on the waiting list",
      register: "Register", registerTitle: "Camp registration",
      participantName: "Participant name", participantBirthdate: "Date of birth",
      parentName: "Parent name (if minor)", parentEmail: "Parent email",
      parentPhone: "Phone", medical: "Medical info",
      notes: "Notes", submit: "Confirm registration",
      success: "Registration received. Confirmation within 48h.",
    },
    motor: {
      eyebrow: "Motor", title: "Motor & boating section.",
      lead: "RYCM also welcomes motorboat and inland boating enthusiasts.",
      securityTitle: "Safety Team",
      securityText: "Our safety team oversees regattas and outings.",
      boatsTitle: "Safety boats", brevetsTitle: "Certificates",
      boats: [
        { tag: "Safety 1", name: "Safety boat 1", text: "Equipped with VHF radio, defibrillator, first-aid kit.", image: "https://images.unsplash.com/photo-1542856391-010fb87dcfed?w=1200" },
        { tag: "Safety 2", name: "Safety boat 2", text: "Equipped with VHF radio, defibrillator, first-aid kit.", image: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=1200" },
        { tag: "Safety 3", name: "Safety boat 3", text: "Equipped with VHF radio, defibrillator, first-aid kit.", image: "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?w=1200" },
      ],
      brevetsList: [
        { name: "Navigation certificate", text: "Required to pilot a motorboat in Belgium." },
        { name: "VHF certificate", text: "Essential maritime radio license." },
      ],
    },
    shop: {
      eyebrow: "Shop", title: "Club colors.",
      lead: "Official clothing & accessories, camp bookings and event registrations. Order online and pick up at the clubhouse.",
      categories: { vetements: "Clothing", accessoires: "Accessories", stages: "Camps", evenements: "Events", all: "All" },
      sectionVet: "Clothing & accessories", sectionStages: "Book a camp", sectionEvents: "Event registrations",
      addToCart: "Add to cart", inStock: "In stock", outOfStock: "Out of stock",
      size: "Size", color: "Color", quantity: "Quantity",
      cartTitle: "My cart", cartEmpty: "Your cart is empty.",
      total: "Total", checkout: "Checkout", remove: "Remove",
      backToShop: "Back to shop",
      waitlistTitle: "This camp is full",
      waitlistText: "Leave your details: we will email you as soon as a spot opens up.",
      waitlistBtn: "Join the waiting list",
      waitlistSuccess: "Noted! You will be emailed as soon as a spot opens up.",
      checkoutTitle: "Complete order",
      contactInfo: "Contact info",
      name: "Full name", email: "Email", phone: "Phone",
      pickupTitle: "Pickup method",
      pickup: "Clubhouse pickup (free)",
      shipping: "Home delivery (extra)",
      address: "Delivery address",
      payNow: "Pay with Mollie", continueShopping: "Continue shopping",
      paymentSuccess: "Payment confirmed!",
      paymentSuccessText: "Thank you! Your order has been received.",
      paymentPending: "Payment processing…",
      paymentFailed: "The payment did not go through. You can retry.",
      noOnlinePayment: "Online payment is not configured yet. Your order is saved — the club will contact you.",
      stageDates: "Dates", places: "Places", placesLeft: "places left",
      stageOpen: "Registrations open", stageFull: "Full", stageClosed: "Closed",
      bookStage: "Book a place", participantInfo: "Participant info",
      participantName: "Participant name", participantNotes: "Notes (medical, allergies…)",
      firstName: "First name", lastName: "Last name", birthdate: "Date of birth",
      weight: "Weight", height: "Height",
      boatType: "Preferred boat", boatMono: "Single-handed", boatBi: "Double-handed",
      experience: "Sailing experience",
      experiencePlaceholder: "Describe your level, previous courses or certifications…",
      requiredFields: "Required fields",
    },
    gallery: {
      eyebrow: "Gallery", title: "Moments at sea.",
      lead: "Club life in pictures.", allYears: "All years",
    },
    contact: {
      eyebrow: "Contact", title: "A question? Write to us.",
      lead: "We reply within 48 hours. For payments, a bank transfer will be communicated.",
      name: "Name", email: "Email", subject: "Subject", message: "Message",
      send: "Send", success: "Message sent.",
      address: "Address", addressValue: "Rue de l'Île Monsin 2, 4020 Liège, Belgium",
      phone: "Phone", hours: "Hours", hoursValue: "Tue–Sun: 9:00 – 18:00",
      bankTitle: "Bank details", bankSub: "For membership, bank transfer only.",
      bankHolder: "Account holder", bankHolderValue: "Royal Yacht Club de la Meuse NPO",
      iban: "IBAN", bic: "BIC", communication: "Reference",
      communicationValue: "Your name + subject",
      followUs: "Follow us",
      faqTitle: "Frequently asked questions",
    },
    auth: {
      loginTitle: "Member login", loginSub: "Access your space.",
      registerTitle: "Create account", registerSub: "Join the community.",
      email: "Email", password: "Password", name: "Full name",
      submitLogin: "Sign in", submitRegister: "Sign up",
      noAccount: "Not a member?", hasAccount: "Already registered?",
      signUpHere: "Sign up", loginHere: "Sign in",
      forgot: "Forgot password?",
      forgotTitle: "Forgot password",
      forgotSub: "Enter your email and we'll send a link.",
      forgotSubmit: "Send link",
      forgotSent: "If the email exists, a link has been generated.",
      resetTitle: "Reset password",
      resetSub: "Choose a new password.",
      newPassword: "New password",
      resetSubmit: "Reset",
      resetSuccess: "Password updated.",
    },
    dashboard: {
      welcome: "Welcome", myReservations: "My bookings",
      newReservation: "New booking",
      noReservations: "No bookings yet.",
      type: "Type", item: "Item", date: "Date", status: "Status", actions: "Actions",
      cancel: "Cancel", cancelled: "Cancelled", pending: "Pending", confirmed: "Confirmed", rejected: "Rejected",
      reserveCourse: "Book a course", reserveBoat: "Book a boat",
      selectItem: "Select", notes: "Notes (optional)",
      confirm: "Confirm", cancelAction: "Close",
      bookingCreated: "Booking created.",
      bookingCancelled: "Booking cancelled.",
      myOrders: "My orders", myStages: "My camps", myDownloads: "Downloads", profileTab: "Profile",
      stage: "Camp", paid: "Paid",
      noOrders: "No orders yet.", noStages: "No camp registrations.", noDownloads: "No member documents yet.",
      profileInfo: "My information", profileSaved: "Saved.", phone: "Phone", address: "Address", saveProfile: "Save",
      changePassword: "Change password", currentPassword: "Current password",
      passwordChanged: "Password updated.", updatePassword: "Update",
    },
    treasury: {
      title: "Treasury space",
      tabs: { summary: "Summary", payments: "Payments", garages: "Garages & parking", fees: "Fees" },
      cats: { cotisation: "Memberships", entry_fee: "Entry fees", garage: "Garages", parking: "Parking", crane: "Crane", ffyb: "FFYB licenses" },
      recordPayment: "Record payment", assignGarage: "Assign garage / parking",
      selectMember: "Select member", selectItem: "Select fee",
    },
    secretary: { title: "Secretariat" },
    admin: {
      title: "Admin dashboard",
      tabs: {
        overview: "Overview", reservations: "Bookings", admissions: "Admissions",
        stages: "Camps", messages: "Messages", orders: "Orders",
        products: "Products", pdfs: "PDF documents",
      },
      stats: {
        users: "Members", reservations: "Bookings", pending: "Pending",
        admissions: "Admissions", new: "New",
        stage_regs: "Camp regs", messages: "Messages", orders: "Orders",
        revenue: "Paid orders", products: "Products",
      },
      approve: "Approve", reject: "Reject", markRead: "Mark read", contact: "Contact",
      uploadPdf: "Upload PDF",
      pdfTitle: "Title", pdfCategory: "Category",
      addProduct: "Add product",
      productName: "Name", productPrice: "Price", productStock: "Stock",
      productCategory: "Category", productSizes: "Sizes (comma separated)",
      productColors: "Colors (comma separated)", productImage: "Image",
      productDesc: "Description",
    },
    footer: {
      tagline: "Royal Yacht Club de la Meuse · Founded in 1928",
      rights: "All rights reserved.",
      legal: "Legal notice", privacy: "Privacy",
    },
    levels: { beginner: "Beginner", intermediate: "Intermediate", advanced: "Advanced" },
  },
};
